import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin, saveAuthData } from '../services/authService';
import { IMAGES } from '../constants/images';
import Snackbar from '../components/common/Snackbar';
import useSnackbar from '../hooks/useSnackbar';
import '../css/AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const savedEmail = localStorage.getItem('rememberedEmail');
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const result = await adminLogin(email, password);

      if (result.status && result.data) {
        saveAuthData(result.data, rememberMe);

        if (rememberMe) {
          localStorage.setItem('rememberedEmail', email);
        } else {
          localStorage.removeItem('rememberedEmail');
        }

        navigate('/admin/management/stores', { replace: true });
        return;
      }
    } catch (err) {
      showSnackbar(err.message || '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.', 'error');
    }
    setIsLoading(false);
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-logo">
        <img src={IMAGES.NOOKLE_ICON} alt="Nookle Logo" />
      </div>

      <div className="admin-login-box">
        <form onSubmit={handleSubmit}>
          <div className="admin-login-form-row">
            <div className="admin-login-inputs">
              <div className="admin-login-input-group">
                <input
                  type="email"
                  placeholder="이메일"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>

              <div className="admin-login-input-group">
                <input
                  type="password"
                  placeholder="비밀번호"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <button
              type="submit"
              className="admin-login-button"
              disabled={isLoading}
            >
              {isLoading ? '로그인 중...' : '로그인'}
            </button>
          </div>

          <div className="admin-login-remember">
            <label>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                disabled={isLoading}
              />
              <span>이메일 기억하기</span>
            </label>
          </div>
        </form>
      </div>

      <Snackbar
        message={snackbar.message}
        type={snackbar.type}
        isOpen={snackbar.isOpen}
        onClose={hideSnackbar}
        duration={3000}
      />
    </div>
  );
};

export default AdminLogin;
